var MeetAjaxForProduct = function (settings) {
  var default_Data = {
    container: "#infinteLoop",
    method: "scroll",
    callback: null,
    loadingText: "Loading Now....",
    pagination: "#infinitePagination",
    offset: 0,
  };

  this.data = Object.assign({}, default_Data, settings);
  this.container = document.querySelector(this.data.container);
  this.pagination = document.querySelector(this.data.pagination);
  this.clickActive = true;
  this.nextPageUrl = null;

  this.scrollHandler = this.checkPaginationInView.bind(this);
  this.resizeHandler = this.scrollHandler;
  this.orientationHandler = this.scrollHandler;

  this.init();
};

MeetAjaxForProduct.prototype.init = function () {
  if (!this.container || !this.pagination) return;

  if (this.data.method === "click") {
    this.enableClick();
  } else if (this.data.method === "scroll") {
    this.enableScroll();
  }
};

MeetAjaxForProduct.prototype.enableScroll = function () {
  window.addEventListener("scroll", this.scrollHandler);
  window.addEventListener("resize", this.resizeHandler);
  window.addEventListener("orientationchange", this.orientationHandler);
};

MeetAjaxForProduct.prototype.enableClick = function () {
  this.link = this.pagination.querySelector("a");
  if (this.link) {
    this.link.addEventListener("click", this.handleClick.bind(this));
  }
};

MeetAjaxForProduct.prototype.handleClick = function (e) {
  e.preventDefault();
  if (!this.clickActive) return;

  this.link.innerHTML = this.data.loadingText;
  this.nextPageUrl = this.link.href;
  this.clickActive = false;
  this.loadMore();
};

MeetAjaxForProduct.prototype.checkPaginationInView = function () {
  if (!this.pagination) return;

  const rect = this.pagination.getBoundingClientRect();
  if (
    rect.top - this.data.offset <= window.innerHeight &&
    rect.bottom + this.data.offset >= 0
  ) {
    this.link = this.pagination.querySelector("a");
    if (this.link) {
      this.nextPageUrl = this.link.href;
      this.link.innerHTML = this.data.loadingText;
      this.removeScrollListeners();
      this.loadMore();
    }
  }
};

MeetAjaxForProduct.prototype.loadMore = function () {
  const loader = document.getElementById("loader");
  if (loader) loader.style.display = "block";

  const xhr = new XMLHttpRequest();
  xhr.open("GET", this.nextPageUrl);
  xhr.responseType = "document";

  xhr.onload = () => {
    const response = xhr.response;
    const newPagination = response.querySelector(this.data.pagination);
    const newContent = response.querySelector(this.data.container);

    if (newContent) {
      this.container.insertAdjacentHTML("beforeend", newContent.innerHTML);
    }

    // Re-init SwatchHover on newly added cards
    if (typeof window.initSwatchHover === 'function') {
      window.initSwatchHover(this.container);
    }

    if (newPagination) {
      this.pagination.innerHTML = newPagination.innerHTML;
    } else {
      this.pagination.innerHTML = "";
    }

    if (typeof this.data.callback === "function") {
      this.data.callback(response);
    }

    if (!response.querySelector(`${this.data.pagination} a`)) {
      this.removeScrollListeners();
      if (loader) loader.style.display = "none";
    } else {
      this.init(); // reinitialize for next page
    }
  };

  xhr.onerror = () => {
    console.error("Failed to fetch next page.");
    if (loader) loader.style.display = "none";
  };

  xhr.send();
};

MeetAjaxForProduct.prototype.removeScrollListeners = function () {
  window.removeEventListener("scroll", this.scrollHandler);
  window.removeEventListener("resize", this.resizeHandler);
  window.removeEventListener("orientationchange", this.orientationHandler);
};

MeetAjaxForProduct.prototype.destroy = function () {
  this.removeScrollListeners();
  if (this.link) {
    this.link.removeEventListener("click", this.handleClick);
  }
};
